import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Popoto3dLogo from "../../containers/popoto3dLogo";
import themeColors from "../../styles/themeColors";
import Link from "../common/Link";

function AboutPopoto() {
  const useStyles = makeStyles((theme) => ({
    about: {
      flexGrow: 1,
      margin: theme.spacing(5),
    },

    link: {
      color: themeColors.accent.main,
      textDecoration: "none",
      fontWeight: "bold",
    },

    gridContent: {
      flex: "1 1 auto !important",
    },
  }));

  const classes = useStyles();
  return (
    <div className={classes.about}>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <Grid item xs={12} className={classes.gridContent}>
          <Popoto3dLogo />
          {/*<a href='https://github.com/Nhogs/popoto'> <img src={popotoLogo} alt='popoto'/> </a>*/}
        </Grid>

        <Grid item xs={10} className={classes.gridContent}>
          <Typography style={{ textAlign: "center", whiteSpace: "pre-line" }}>
            <Link href="https://github.com/Nhogs/popoto" text="Popoto.js" /> is
            a JavaScript library built with{" "}
            <Link href="https://d3js.org/" text="D3.js" /> designed to create
            interactive and customizable visual query builder for{" "}
            <Link href="https://neo4j.com/" text="Neo4j" /> graph databases.
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

AboutPopoto.propTypes = {};
export default AboutPopoto;
